import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PercentageInputComponent } from './controls/percentage-input/percentage-input.component';
import { DisableControlDirective } from './directives/disable-control.directive';
import { IndeterminateDirective } from './directives/indeterminate.directive';
import { MaxDirective } from './directives/max.directive';
import { NumberInputDirective } from './directives/number-input.directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

const PUBLIC_DECLARATIONS = [
  DisableControlDirective,
  IndeterminateDirective,
  MaxDirective,
  NumberInputDirective,
  PercentageInputComponent,
];

@NgModule({
  declarations: [PUBLIC_DECLARATIONS, PercentageInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NgxMaskDirective,
  ],
  providers: [provideNgxMask()],
  exports: [PUBLIC_DECLARATIONS],
})
export class InputModule {}
